module.exports = __webpack_public_path__ + "img/razzia-finanzministerium.f09581e2.png";